module.exports = __webpack_public_path__ + "static/media/Alien League II 3D-01.8af6da47.svg";